"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenCheckoutAction = void 0;
const client_shared_1 = require("@teams/client-shared");
const adaptivecards_1 = require("adaptivecards");
const CardHelper_1 = require("../utils/CardHelper");
const OpenCheckoutAction = (domainOrigin, application, title, trackingSource, isTrial, isPrimary) => {
    const url = (0, client_shared_1.getStripeCheckoutUrl)(application, trackingSource, isTrial);
    return CardHelper_1.CardHelper.create(adaptivecards_1.OpenUrlAction, {
        title,
        isPrimary,
        url: `${domainOrigin}${url}`,
    });
};
exports.OpenCheckoutAction = OpenCheckoutAction;
//# sourceMappingURL=OpenCheckoutAction.js.map